module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-manifest@5.15.0_gatsby@5.15.0_babel-eslint@10.1.0_eslint@8.57.1__react-dom@18.3_nswtigibjhx2677k5nuawme5bq/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Noel Rajan's Portfolio","short_name":"Noel's Portfolio","start_url":"/","theme_color_in_head":false,"display":"browser","icon":"src/images/terminal.svg","legacy":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"8f4c670e81e5c15b19a720200d067bf0"},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.15.0_babel-eslint@10.1.0_eslint@8.57.1__react-dom@18.3.1_react@18.3.1__react@18.3.1__rycu234q5uzbsoymfjl33mevni/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
